import { StatsGameGroup } from "../../models/statisticModel";

const gameListInterface: StatsGameGroup[] = [
    {
        id: 'xosotruyenthong',
        title: 'Xổ Số Truyền Thống',
        is3rdGame: false,
        gameGroup: [
            { id: 'mienbac', label: 'Miền Bắc', key: 'mienbac', groupType: 'lottery', gameId: 200 },
            { id: 'mienbac', label: 'Đặc Biệt 18h25', key: 'demienbac', groupType: 'lottery', gameId: 201 },

            { id: 'mienbac', label: 'Việt nam 00h', key: 'xstt00h', groupType: 'lottery', gameId: 210 },
            { id: 'mienbac', label: 'Việt nam 01h', key: 'xstt01h', groupType: 'lottery', gameId: 211 },
            { id: 'mienbac', label: 'Việt nam 02h', key: 'xstt02h', groupType: 'lottery', gameId: 212 },
            { id: 'mienbac', label: 'Việt nam 03h', key: 'xstt03h', groupType: 'lottery', gameId: 213 },
            { id: 'mienbac', label: 'Việt nam 04h', key: 'xstt04h', groupType: 'lottery', gameId: 214 },
            { id: 'mienbac', label: 'Việt nam 05h', key: 'xstt05h', groupType: 'lottery', gameId: 215 },
            { id: 'mienbac', label: 'Việt nam 06h', key: 'xstt06h', groupType: 'lottery', gameId: 216 },
            { id: 'mienbac', label: 'Việt nam 07h', key: 'xstt07h', groupType: 'lottery', gameId: 217 },
            { id: 'mienbac', label: 'Việt nam 08h', key: 'xstt08h', groupType: 'lottery', gameId: 218 },
            { id: 'mienbac', label: 'Việt nam 09h', key: 'xstt09h', groupType: 'lottery', gameId: 219 },
            { id: 'mienbac', label: 'Việt nam 10h', key: 'xstt10h', groupType: 'lottery', gameId: 220 },
            { id: 'mienbac', label: 'Việt nam 11h', key: 'xstt11h', groupType: 'lottery', gameId: 221 },
            { id: 'mienbac', label: 'Việt nam 12h', key: 'xstt12h', groupType: 'lottery', gameId: 222 },
            { id: 'mienbac', label: 'Việt nam 13h', key: 'xstt13h', groupType: 'lottery', gameId: 223 },
            { id: 'mienbac', label: 'Việt nam 14h', key: 'xstt14h', groupType: 'lottery', gameId: 224 },
            { id: 'mienbac', label: 'Việt nam 15h', key: 'xstt15h', groupType: 'lottery', gameId: 225 },
            { id: 'mienbac', label: 'Việt nam 16h', key: 'xstt16h', groupType: 'lottery', gameId: 226 },
            { id: 'mienbac', label: 'Việt nam 17h', key: 'xstt17h', groupType: 'lottery', gameId: 227 },
            { id: 'mienbac', label: 'Việt nam 18h', key: 'xstt18h', groupType: 'lottery', gameId: 228 },
            { id: 'mienbac', label: 'Việt nam 19h', key: 'xstt19h', groupType: 'lottery', gameId: 229 },
            { id: 'mienbac', label: 'Việt nam 20h', key: 'xstt20h', groupType: 'lottery', gameId: 230 },
            { id: 'mienbac', label: 'Việt nam 21h', key: 'xstt21h', groupType: 'lottery', gameId: 231 },
            { id: 'mienbac', label: 'Việt nam 22h', key: 'xstt22h', groupType: 'lottery', gameId: 232 },
            { id: 'mienbac', label: 'Việt nam 23h', key: 'xstt23h', groupType: 'lottery', gameId: 233 },

            { id: '', label: 'Tổng Miền Bắc', key: 'totalmienbac', groupType: 'lottery' },
            { id: 'mientrung', label: 'Thừa Thiên Huế', key: 'hue', groupType: 'lottery', gameId: 126 },
            { id: 'mientrung', label: 'Phú Yên', key: 'phuyen', groupType: 'lottery', gameId: 127 },
            { id: 'mientrung', label: 'Đắc Lắc', key: 'daclac', groupType: 'lottery', gameId: 128 },
            { id: 'mientrung', label: 'Quảng Nam', key: 'quangnam', groupType: 'lottery', gameId: 129 },
            { id: 'mientrung', label: 'Đà Nẵng', key: 'danang', groupType: 'lottery', gameId: 130 },
            { id: 'mientrung', label: 'Khánh Hòa', key: 'khanhhoa', groupType: 'lottery', gameId: 131 },
            { id: 'mientrung', label: 'Bình Định', key: 'binhdinh', groupType: 'lottery', gameId: 132 },
            { id: 'mientrung', label: 'Quảng Trị', key: 'quangtri', groupType: 'lottery', gameId: 133 },
            { id: 'mientrung', label: 'Quảng Bình', key: 'quangbinh', groupType: 'lottery', gameId: 134 },
            { id: 'mientrung', label: 'Gia Lai', key: 'gialai', groupType: 'lottery', gameId: 135 },
            { id: 'mientrung', label: 'Ninh Thuận', key: 'ninhthuan', groupType: 'lottery', gameId: 136 },
            { id: 'mientrung', label: 'Quảng Ngãi', key: 'quangngai', groupType: 'lottery', gameId: 137 },
            { id: 'mientrung', label: 'Đắc Nông', key: 'dacnong', groupType: 'lottery', gameId: 138 },
            { id: 'mientrung', label: 'Kon Tum', key: 'kontum', groupType: 'lottery', gameId: 139 },
            { id: '', label: 'Tổng Miền Trung', key: 'totalmientrung', groupType: 'lottery' },
            { id: 'miennam', label: 'Hồ Chí Minh', key: 'hcm', groupType: 'lottery', gameId: 105 },
            { id: 'miennam', label: 'Cà Mau', key: 'camau', groupType: 'lottery', gameId: 107 },
            { id: 'miennam', label: 'Đà Lạt', key: 'dalat', groupType: 'lottery', gameId: 125 },
            { id: 'miennam', label: 'Bến Tre', key: 'bentre', groupType: 'lottery', gameId: 108},
            { id: 'miennam', label: 'Vũng Tàu', key: 'vungtau', groupType: 'lottery', gameId: 109 },
            { id: 'miennam', label: 'Bạc Liêu', key: 'baclieu', groupType: 'lottery', gameId: 110 },
            { id: 'miennam', label: 'Đồng Nai', key: 'dongnai', groupType: 'lottery', gameId: 111 },
            { id: 'miennam', label: 'Cần Thơ', key: 'cantho', groupType: 'lottery', gameId: 112 },
            { id: 'miennam', label: 'Sóc Trăng', key: 'soctrang', groupType: 'lottery', gameId: 113 },
            { id: 'miennam', label: 'Tây Ninh', key: 'tayninh', groupType: 'lottery', gameId: 114 },
            { id: 'miennam', label: 'An Giang', key: 'angiang', groupType: 'lottery', gameId: 115 },
            { id: 'miennam', label: 'Bình Thuận', key: 'binhthuan', groupType: 'lottery', gameId: 116 },
            { id: 'miennam', label: 'Vĩnh Long', key: 'vinglong', groupType: 'lottery', gameId: 117 },
            { id: 'miennam', label: 'Bình Dương', key: 'binhduong', groupType: 'lottery', gameId: 118 },
            { id: 'miennam', label: 'Trà Vinh', key: 'travinh', groupType: 'lottery', gameId: 119 },
            { id: 'miennam', label: 'Long An', key: 'longan', groupType: 'lottery', gameId: 120},
            { id: 'miennam', label: 'Bình Phước', key: 'binhphuoc', groupType: 'lottery', gameId: 121 },
            { id: 'miennam', label: 'Hậu Giang', key: 'haugiang', groupType: 'lottery', gameId: 122 },
            { id: 'miennam', label: 'Tiền Giang', key: 'tiengiang', groupType: 'lottery', gameId: 123 },
            { id: 'miennam', label: 'Kiên Giang', key: 'kiengiang', groupType: 'lottery', gameId: 124 },
            { id: 'miennam', label: 'Đồng Tháp', key: 'dongthap', groupType: 'lottery', gameId: 106 },
            { id: '', label: 'Tổng Miền Nam', key: 'totalmiennam', groupType: 'lottery' },
        ],
    },

    {
        id: 'xosovip',
        title: 'Xổ Số VIP + Trực tiếp',
        is3rdGame: false,
        gameGroup: [

            { id: 'mienbac', label: 'Hà Nội VIP 19h10', key: 'hnvip', groupType: 'lottery', gameId: 202 },
            { id: 'mienbac', label: 'Thủ đô VIP 12h10', key: 'td12h15', groupType: 'lottery', gameId: 204 },
            { id: 'mienbac', label: 'Việt nam 24h', key: 'vn24h', groupType: 'lottery', gameId: 99 },
            { id: 'miennam', label: 'Đà Nẵng VIP 17h10', key: 'dnvip', groupType: 'lottery', gameId: 207 },
            { id: 'miennam', label: 'Sài gòn VIP 15h10', key: 'sg15h15', groupType: 'lottery', gameId: 206 },
            { id: '', label: 'Tổng', key: 'vip', groupType: 'fastlottery' },
        ],
    },

    {
        id: 'xosonhanh',
        title: 'Xổ Số Nhanh',
        is3rdGame: false,
        gameGroup: [
            { id: 'xosonhanh', label: 'Siêu Tốc 1 Giây', key: 'mmc', groupType: 'fastlottery', gameId: 50 },
            { id: 'xosonhanh', label: 'Siêu Tốc 45 Giây', key: 'xs45s', groupType: 'fastlottery', gameId: 100 },
            { id: 'xosonhanh', label: 'Siêu Tốc 1 Phút', key: 'xs1m', groupType: 'fastlottery', gameId: 101 },
            { id: 'xosonhanh', label: 'Siêu Tốc 1.5 Phút', key: 'xs1m30s', groupType: 'fastlottery', gameId: 102 },
            { id: 'xosonhanh', label: 'Siêu Tốc 2 Phút', key: 'xs2m', groupType: 'fastlottery', gameId: 103 },
            { id: 'xosonhanh', label: 'Siêu Tốc 5 Phút', key: 'xs5m', groupType: 'fastlottery', gameId: 104 },

            { id: 'xosonhanh', label: 'Miền Bắc 1 Giây', key: 'xsmb1s', groupType: 'lottery', gameId: 140 },
            { id: 'xosonhanh', label: 'Miền Bắc 45 Giây', key: 'xsmb45s', groupType: 'lottery', gameId: 141 },
            { id: 'xosonhanh', label: 'Miền Bắc 1 Phút', key: 'xsmb1m', groupType: 'lottery', gameId: 142 },
            { id: 'xosonhanh', label: 'Miền Bắc 1 Phút 30 Giây', key: 'xsmb1m30s', groupType: 'lottery', gameId: 143 },
            { id: 'xosonhanh', label: 'Miền Bắc 2 Phút', key: 'xsmb2m', groupType: 'lottery', gameId: 144 },
            { id: 'xosonhanh', label: 'Miền Bắc 5 Phút', key: 'xsmb5m', groupType: 'lottery', gameId: 145 },

            { id: '', label: 'Tổng', key: 'totalxosonhanh', groupType: 'fastlottery' },
        ],
    },
    {
        id: 'dangian',
        title: 'Dân Gian',
        is3rdGame: false,
        gameGroup: [
            { id: 'dangian', label: 'Xóc Đĩa 1 Giây', key: 'xd1s', groupType: 'traditional' },
            { id: 'dangian', label: 'Xóc Đĩa 1 Phút', key: 'xd1m', groupType: 'traditional' },
            { id: 'dangian', label: 'Bầu Cua 1 Giây', key: 'bc1s', groupType: 'traditional' },
            { id: 'dangian', label: 'Bầu Cua 1 Phút', key: 'bc1m', groupType: 'traditional' },
            { id: '', label: 'Tổng', key: 'totaldangian', groupType: 'traditional' },
        ],
    },
    // {
    //     id: 'minigame',
    //     title: 'Mini Game',
    //     is3rdGame: false,
    //     gameGroup: [
    //         { id: 'minigame', label: 'Tài Xỉu Cân Bảng', key: 'sicbo', groupType: 'minigame' },
    //         { id: 'minigame', label: 'Xóc Dĩa', key: 'xocdia', groupType: 'minigame' },
    //         { id: '', label: 'Tổng', key: 'totalminigame', groupType: 'minigame' },
    //     ],
    // },
];

export default gameListInterface;
